function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import { red600, gray800 } from '../../theme/colors';
import { size4, size8, size12, size14, size20 } from '../../theme/scale';
import { fontSemiBold, fontRegular, fontBuenosAiresRegular } from '../../theme/fonts';
import { labelFontSize } from '../../utils/helpers';
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${fontSemiBold};
  width: ${({
  width
}) => width || '100%'};
`;
const Label = styled.label`
  color: ${gray800};
  font-family: ${({
  joyableTheme
}) => joyableTheme ? fontBuenosAiresRegular : fontSemiBold};
  ${({
  joyableTheme
}) => joyableTheme && 'font-weight: 700;'}
  font-size: ${labelFontSize};
  margin-bottom: ${size4};
  ${({
  hideLabel
}) => hideLabel && `
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  `}
`;
const StyledParagraph = styled.p`
  font-size: ${size14};
  font-family: ${({
  joyableTheme
}) => joyableTheme ? fontBuenosAiresRegular : fontRegular};
`;
const Hint = styled(StyledParagraph)`
  color: ${gray800};
  margin-bottom: ${size8};
`;
const Caption = styled(StyledParagraph)`
  color: ${gray800};
  margin-top: ${size8};
`;
const ErrorMessage = styled(StyledParagraph)`
  color: ${red600};
  margin-top: ${size8};
`;
const PreservedErrorMessage = styled.span`
  color: ${red600};
  font-size: ${size12};
  margin-top: ${size4};
  min-height: ${size20};
`;
export const InputWrapper = ({
  id,
  label,
  hint,
  errorMessage,
  isErrorSpacePreserved,
  children,
  labelProps,
  hideLabel = false,
  smallLabel = false,
  caption,
  isNumber,
  joyableTheme = false,
  labelAriaDescribedby,
  captionAriaDescribedby,
  hintAriaDescribedby,
  errorMessageAriaDescribedby,
  ...rest
}) => {
  const showCaption = isNumber ? !errorMessage && !!caption : !!caption;
  return /*#__PURE__*/React.createElement(Wrapper, rest, label && /*#__PURE__*/React.createElement(Label, _extends({
    id: labelAriaDescribedby
  }, labelProps, {
    htmlFor: id,
    hideLabel,
    smallLabel,
    joyableTheme
  }), label), hint && /*#__PURE__*/React.createElement(Hint, {
    id: hintAriaDescribedby,
    joyableTheme
  }, hint), children, errorMessage && !isErrorSpacePreserved && /*#__PURE__*/React.createElement(ErrorMessage, {
    id: errorMessageAriaDescribedby
  }, errorMessage), isErrorSpacePreserved && /*#__PURE__*/React.createElement(PreservedErrorMessage, {
    "aria-live": "polite",
    id: errorMessageAriaDescribedby
  }, !!errorMessage ? errorMessage : ''), showCaption && /*#__PURE__*/React.createElement(Caption, {
    id: captionAriaDescribedby
  }, caption));
};
export default InputWrapper;
//# sourceMappingURL=index.js.map